import { IChildrenProps } from "../interfaces/IChildrenProps";
import KeycloakService from "../services/KeycloakService";

const RenderOnAuthenticated = ({ children }: IChildrenProps) => {
    return (KeycloakService.isLoggedIn()) ? children : null;
};

export default RenderOnAuthenticated;